import request from "@/utils/request"

// 后台用户列表
export function AdminuserList(pageIndex, pageSize, name) {
  return request({
    url: "/admin-user/pagination",
    method: "POST",
    data: {
      pageIndex,
      pageSize,
      name
    }
  })
};

// 创建后台用户
export function CreateAdminuser(name, nickname, password, uid, company, tel) {
  return request({
    url: "/admin-user/add",
    method: "POST",
    data: {
      name, nickname, password, uid, company, tel
    }
  })
};

// 删除后台用户
export function DelAdminuser(id) {
  return request({
    url: `/admin-user/` + id,
    method: "DELETE",
  })
};

//查看后台用户信息
export function AdminuserInfo(id) {
  return request({
    url: `/admin-user/findById/` + id,
    method: "POST",
  })
};

//查看后台用户当前菜单
export function getAdminuserRoles(adminuserId) {
  return request({
    url: `/admin-user/findAdminuserRoles/` + adminuserId,
    method: "GET",
  })
};

// 修改后台用户信息
export function upDataAdminuserInfo(id, name, nickname, password, uid, company, tel) {
  return request({
    url: `/admin-user/save`,
    method: "POST",
    data: {
      id, name, nickname, password, uid, company, tel
    }
  })
}
// 保存后台用户当前菜单
export function saveAdminuserRoles(adminUserId, roleIds) {
  return request({
    url: `/admin-user/assign`,
    method: "POST",
    data: {
      adminUserId,
      roleIds,
    }
  })
}

// 冻结用户
export function freezeUser(id, reason) {
  return request({
    url: `/admin-user/freeze/${id}`,
    method: "POST",
    params: {
      reason
    }
  })
}

// 解冻用户
export function unfreezeUser(id, reason) {
  return request({
    url: `/admin-user/unfreeze/${id}`,
    method: "POST",
    params: {
      reason
    }
  })
}

// 查询用户冻结记录
export function getFreezeRecords(userId) {
  return request({
    url: `/admin-user/freeze-records/${userId}`,
    method: "GET"
  })
}
